import { shrpaApi } from "./axios";

// Types
import { CreatorPackage, CreatorPackagePayload } from "@contracts/creatorPackages";

export default {
  async loadAllPackages(creatorId: string): Promise<Array<CreatorPackage>> {
    let uri = `/creator/${creatorId}/packages`;
    const { data } = await shrpaApi.get<Array<CreatorPackage>>(uri);

    return data;
  },

  async loadPackage(creatorId: string, packageId: string): Promise<CreatorPackage> {
    let uri = `/creator/${creatorId}/packages/${packageId}`;
    const { data } = await shrpaApi.get<CreatorPackage>(uri);

    return data;
  },

  async createPackage(creatorId: string, packagePayload: CreatorPackagePayload): Promise<CreatorPackage> {
    let uri = `/creator/${creatorId}/packages`;
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.post<CreatorPackage>(uri, JSON.stringify(packagePayload), config);

    return data;
  },

  async updatePackage(creatorId: string, packageId: string, packagePayload: CreatorPackagePayload): Promise<CreatorPackage> {
    let uri = `/creator/${creatorId}/packages/${packageId}`;
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.put<CreatorPackage>(uri, JSON.stringify(packagePayload), config);

    return data;
  },

  async deletePackage(creatorId: string, packageId: string): Promise<boolean> {
    let uri = `/creator/${creatorId}/packages/${packageId}`;
    const { data } = await shrpaApi.delete<boolean>(uri);

    return data;
  },
};
